import React from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Calendar, List, Users, User, Truck, ArrowLeft, LogOut } from 'lucide-react';
import { removeToken } from '../../../utils/auth';
import '../../../styles/admin/production/ProductionLayout.css';

const ProductionLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    removeToken();
    navigate('/admin');
  };

  const navItems = [
    { path: '/admin/production/dispatch', label: 'Dispatch', icon: <Calendar /> },
    { path: '/admin/production/calendar', label: 'Calendrier', icon: <Calendar /> },
    { path: '/admin/production/jobs', label: 'Liste Jobs', icon: <List /> },
    { path: '/admin/production/teams', label: 'Équipes', icon: <Users /> },
    { path: '/admin/production/employees', label: 'Employés', icon: <User /> },
    { path: '/admin/production/vehicles', label: 'Véhicules', icon: <Truck /> },
  ];

  return (
    <div className="production-layout">
      {/* Header */}
      <div className="production-header">
        <div className="production-header-content">
          <div className="header-left">
            <div className="logo-section">
              <img 
                src="/nvf-logo-official.png" 
                alt="NVF" 
                style={{
                  height: '56px',
                  width: 'auto',
                  objectFit: 'contain',
                  marginRight: '16px'
                }}
              />
              <div>
                <h1>Production & Planning</h1>
                <p className="tagline">Gestion des interventions terrain</p>
              </div>
            </div>
          </div>
          <div className="header-right">
            <Link to="/admin/erp" className="btn-header-secondary">
              <ArrowLeft size={20} />
              Retour ERP
            </Link>
            <button onClick={handleLogout} className="btn-header-secondary">
              <LogOut size={20} />
              Déconnexion
            </button>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <div className="production-nav">
        <div className="production-nav-content">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            >
              {item.icon}
              <span>{item.label}</span>
            </Link>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="production-content">
        <Outlet />
      </div>
    </div>
  );
};

export default ProductionLayout;